<app-navbar></app-navbar>

<!-- ─── HERO ──────────────────────────────────────────────────────── -->
<section class="pg-hero">
  <div class="pg-hero-bg">
    <div class="pg-glow pg-glow-1"></div>
    <div class="pg-glow pg-glow-2"></div>
    <div class="pg-glow pg-glow-3"></div>
    <div class="pg-hero-dots"></div>
  </div>

  <div class="container" style="position:relative;z-index:2;">
    <div class="pg-hero-inner">
      <!-- Left text -->
      <div class="pg-hero-text">
        <div class="pg-hero-chip wow fadeInDown" data-wow-delay="0.1s">
          <i class="ri-image-2-fill"></i>
          <span>Memories &amp; Moments</span>
        </div>
        <h1 class="pg-hero-title wow fadeInUp" data-wow-delay="0.2s">
          Photo <span class="pg-text-grad">Gallery</span>
        </h1>
        <p class="pg-hero-desc wow fadeInUp" data-wow-delay="0.3s">
          Browse through our collection of albums capturing every milestone, event and celebration.
        </p>
        <nav class="pg-breadcrumb wow fadeInUp" data-wow-delay="0.4s">
          <a routerLink="/"><i class="ri-home-4-line"></i> Home</a>
          <i class="ri-arrow-right-s-line"></i>
          <span>Photo Gallery</span>
        </nav>
      </div>

      <!-- Right decorative camera visual -->
      <div class="pg-hero-visual wow fadeInRight" data-wow-delay="0.25s">
        <div class="pg-cam-wrap">
          <div class="pg-cam-ring pg-cr-1"></div>
          <div class="pg-cam-ring pg-cr-2"></div>
          <div class="pg-cam-ring pg-cr-3"></div>
          <div class="pg-cam-center">
            <i class="ri-camera-3-fill"></i>
          </div>
          <div class="pg-float-badge pg-fb-1"><i class="ri-image-line"></i> Albums</div>
          <div class="pg-float-badge pg-fb-2"><i class="ri-gallery-line"></i> Moments</div>
          <div class="pg-float-badge pg-fb-3"><i class="ri-landscape-line"></i> Events</div>
        </div>
      </div>
    </div>
  </div>

  <div class="pg-hero-wave">
    <svg viewBox="0 0 1440 70" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0,35 C360,70 1080,0 1440,35 L1440,70 L0,70 Z" fill="#f1f5f9"/>
    </svg>
  </div>
</section>

<!-- ─── TAB SWITCHER ──────────────────────────────────────────────── -->
<div class="pg-tab-bar">
  <div class="container">
    <div class="pg-tabs">
      <button class="pg-tab-btn" [class.pg-tab-active]="selectedItem === 'photo-gallery'">
        <i class="ri-image-2-line"></i> Photos
      </button>
      <button class="pg-tab-btn" [class.pg-tab-active]="selectedItem === 'video-gallery'" (click)="selectItem()">
        <i class="ri-video-line"></i> Videos
      </button>
    </div>
  </div>
</div>

<!-- ─── ALBUMS GRID ───────────────────────────────────────────────── -->
<section class="pg-section">
  <div class="container">

    <!-- Section header -->
    <div class="pg-sec-header wow fadeInUp" data-wow-delay="0.1s" *ngIf="ImageAlbums?.length">
      <div class="pg-sec-line"></div>
      <span class="pg-sec-label"><i class="ri-folder-image-line"></i> All Albums</span>
      <div class="pg-sec-line"></div>
    </div>

    <!-- Loading skeletons -->
    <div class="pg-skeleton-grid" *ngIf="fetchinData">
      <div class="pg-skeleton-card" *ngFor="let _ of [1,2,3,4,5,6,7,8]">
        <div class="pg-skeleton-img"></div>
        <div class="pg-skeleton-bar"></div>
        <div class="pg-skeleton-bar pg-skeleton-bar-sm"></div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="pg-empty" *ngIf="!fetchinData && ImageAlbums == null">
      <div class="pg-empty-icon"><i class="ri-image-2-line"></i></div>
      <h3>No Albums Yet</h3>
      <p>Photo albums will appear here once they are added.</p>
      <a routerLink="/" class="pg-empty-btn"><i class="ri-home-4-line"></i> Back to Home</a>
    </div>

    <!-- Album cards -->
    <div class="pg-grid" *ngIf="!fetchinData && ImageAlbums != null">
      <div class="pg-album-card wow fadeInUp"
           *ngFor="let album of ImageAlbums; let i = index"
           [attr.data-wow-delay]="(i % 4 * 0.08 + 0.1) + 's'"
           [routerLink]="['/imageFolder', album.Id]">

        <!-- Image panel -->
        <div class="pg-card-img-wrap">
          <!-- Spinner while loading -->
          <div class="pg-img-spinner" [class.pg-img-loaded]="imageLoaded">
            <svg viewBox="0 0 16 18"><path class="pg-spin-path" fill="none" stroke-width="2" d="M7.21487 1.2868C7.88431 0.9044 8.73031 0.9044 9.39974 1.2868L9.40283 1.28856L14.4613 4.20761C15.1684 4.598 15.5746 5.33558 15.5746 6.11465V8.99996V11.8853C15.5746 12.6507 15.1632 13.3848 14.4617 13.7721L9.37973 16.7132C8.71029 17.0956 7.86428 17.0956 7.19485 16.7132L7.19088 16.7109L2.11279 13.772C1.40602 13.3816 1 12.6441 1 11.8653V8.98995V6.11465C1 5.31458 1.44381 4.59039 2.10827 4.21051L7.21487 1.2868Z"/></svg>
          </div>

          <img [src]="album.ThumbnailLink ? TransformUrl(album.ThumbnailLink) : ''"
               [alt]="album.Name"
               (load)="onImageLoad()"
               onerror="this.style.opacity='0'">

          <!-- No-image fallback pattern -->
          <div class="pg-no-img" [ngClass]="'pg-color-' + (i % 6)"
               *ngIf="!album.ThumbnailLink">
            <i class="ri-image-2-line"></i>
          </div>

          <!-- Dark overlay -->
          <div class="pg-card-overlay"></div>

          <!-- Album number pill -->
          <span class="pg-album-num"># {{ i + 1 }}</span>

          <!-- Hover zoom icon -->
          <div class="pg-zoom-icon">
            <i class="ri-zoom-in-line"></i>
          </div>

          <!-- Photo label bottom -->
          <span class="pg-photo-pill">
            <i class="ri-image-line"></i> Photos
          </span>
        </div>

        <!-- Card footer with title -->
        <div class="pg-card-footer">
          <div class="pg-album-info">
            <div class="pg-album-icon">
              <i class="ri-folder-image-fill"></i>
            </div>
            <div>
              <h5 class="pg-album-name">{{ album.Name }}</h5>
              <span class="pg-album-sub">Click to view photos</span>
            </div>
          </div>
          <div class="pg-arrow-btn">
            <i class="ri-arrow-right-line"></i>
          </div>
        </div>

        <!-- Glow on hover -->
        <div class="pg-card-glow"></div>
      </div>
    </div>

  </div>
</section>
